import React, { PropsWithChildren } from "react";
import { Text } from "../../general/Text";
import { GlobalStore } from "../../../store/global/GlobalStore";
import { css } from "@emotion/react";

export const DetailsLeftColumnText = ({ children }: PropsWithChildren) => {
  const theme = GlobalStore.useState(s => s.theme);
  return (
    <Text
      textStyle="Paragraph"
      size="Large"
      color={theme.font.secondary.default}
      textCss={css`
        display: flex;
        align-items: center;
      `}
    >
      {children}
    </Text>
  );
};
